<section class="garage-page" aria-labelledby="garage-title">
  <div class="garage-hero">
    <div>
      <p class="eyebrow">Inventory Command Center</p>
      <h1 id="garage-title">Curate every upcoming car in one premium workspace.</h1>
      <p class="garage-lead">A Figma-inspired dashboard for scanning launch-ready models, pricing, imagery, and next best actions without losing context.</p>
    </div>
    <a [routerLink]="['/addcar']" class="btn btn-primary hero-action">
      <i class="fas fa-plus" aria-hidden="true"></i>
      Add a Car
    </a>
  </div>

  <div class="garage-stats" *ngIf="!isLoading && cars && cars.length > 0" aria-label="Inventory summary">
    <article>
      <span>Total Models</span>
      <strong>{{ cars.length }}</strong>
    </article>
    <article>
      <span>Visual Records</span>
      <strong>{{ cars.length }}</strong>
    </article>
    <article>
      <span>CRM Status</span>
      <strong>Live</strong>
    </article>
  </div>

  <div *ngIf="isLoading" class="loading-card" role="status" aria-live="polite">
    <div class="spinner-border text-primary" aria-hidden="true"></div>
    <div>
      <h2>Loading cars...</h2>
      <p>Preparing the premium inventory experience.</p>
    </div>
  </div>

  <div *ngIf="!isLoading && (!cars || cars.length === 0)" class="empty-state text-center">
    <img src="/assets/img/car_0.jpg" alt="No cars available" />
    <p class="eyebrow">No inventory yet</p>
    <h2>Add your first upcoming car</h2>
    <p class="text-muted">Start building a launch-ready catalog with pricing, imagery, and details for every model on your shortlist.</p>
    <a [routerLink]="['/addcar']" class="btn btn-primary mt-2">Add a Car</a>
  </div>

  <div *ngIf="!isLoading && cars && cars.length > 0" class="inventory-panel">
    <div class="panel-header">
      <div>
        <p class="eyebrow">Garage list</p>
        <h2>Upcoming car inventory</h2>
      </div>
      <span>{{ cars.length }} active records</span>
    </div>

    <div class="car-grid" aria-label="Upcoming car cards">
      <article class="car-card" *ngFor="let car of cars">
        <div class="car-image-wrap">
          <img *ngIf="car.retrievedImage" [src]="car.retrievedImage" [alt]="car.carName || 'Car photo'" />
          <img *ngIf="!car.retrievedImage && car.imageName" [src]="getCarImageUrl(car.imageName)" [alt]="car.carName || 'Car photo'" />
          <img *ngIf="!car.retrievedImage && !car.imageName" src="/assets/img/car_0.jpg" [alt]="car.carName || 'Car photo'" />
          <span class="image-badge">ID {{ car.carId }}</span>
        </div>
        <div class="car-card-body">
          <div>
            <p class="car-label">Upcoming model</p>
            <h3>{{ car.carName }}</h3>
          </div>
          <dl>
            <div>
              <dt>Price</dt>
              <dd>{{ car.price }}</dd>
            </div>
            <div>
              <dt>Status</dt>
              <dd>Ready</dd>
            </div>
          </dl>
          <div class="card-actions" aria-label="Car actions">
            <button (click)="carDetails(car.carId)" class="btn btn-outline-primary">View</button>
            <button (click)="updateCar(car.carId)" class="btn btn-info">Update</button>
            <button (click)="deleteCar(car.carId)" class="btn btn-danger">Delete</button>
          </div>
        </div>
      </article>
    </div>
  </div>
</section>
